import React from "react";
import { NavLink } from "react-router-dom";

function BannerHomepage() {
  return (
    <section className="section-banner-homepage">
      <div className="banner-content-container">
        <NavLink className="btn btn-banner-decouvrir" to="/produits">
          DÉCOUVREZ NOS PRODUITS
        </NavLink>
      </div>
    </section>
  );
}

export default BannerHomepage;
